/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable camelcase */
import { Feature, TitlebarService } from '@tencent/workbench';
import BaseTopMenuFeature from '@framework/workbench/common/feature/base-top-menu-feature';
import { Snackbar } from '@tencent/dui/lib/components/Snackbar';
import i18n from '@i18next/i18n';
import axios from 'axios';
import ArkLoader from '@src/js/common/ark-extensions';
import { getSecretId } from '@src/js/common/utils';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { getXSRF } from '@src/slide/domain/slide-app/utils/cookie-utils';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';

@Feature()
export class CertificationFeature extends BaseTopMenuFeature {
    constructor(private readonly titlebarService: TitlebarService) {
        super();
    }

    public isCertificationHide() {
        return !(
            ArkLoader.extensionService.dependentServiceCombinder.accountApplication.officialInfo?.credential
            && SlideDataServices.DocInfoManager()?.isOwner
            && !ENV.DRIVE_ENV.IS_CLOUD_SLIDE
        );
    }

    public async handleSwitch() {
        const { certification = false } = window.clientVars?.docInfo ?? {};
        const result = await this.doSwitch();
        if (result) {
            // 统一顶部栏的数据统一从domain获取，在菜单中打开或关闭认证开关时，需要更新domain中的数据
            ArkLoader.extensionService.dependentServiceCombinder.
                docMetaDomain.docMetaEntity.
                updateOfficialAuthInfo(getSecretId());
            this.titlebarService.update();
            const messageText = certification.isCertification ? this.getCloseTips(true) : this.getOpenTips(true);
            Snackbar.show({
                message: messageText,
                type: 'success',
            });
            return;
        }
    }

    /**
     * 进行开关切换操作
     */
    protected async doSwitch() {
        const { certification } = window.clientVars?.docInfo ?? {};
        const { wechatOfficialAccount } = window.clientVars?.userInfo ?? {};
        const { avatar, nick, type, principal } = wechatOfficialAccount ?? {};
        try {
            const result = await this.switchCertification(certification?.isCertification);
            if (result === 0) {
                window.clientVars.docInfo.certification = {
                    isCertification: !certification?.isCertification,
                    certificationAvatar: avatar, // 认证帐号头像
                    certificationNick: nick, // 认证帐号名称
                    certificationType: type, // 认证帐号类型
                    certificationSubject: principal, // 认证帐号主体
                };
                return true;
            }
            return false;
        } catch (e) {
            return true;
        }
    }

    /*
     * 设置是否显示认证信息
     */
    private async switchCertification(isCancel: boolean) {
        try {
            const url = `//${location.host}/v2/file/authenticate`;
            const padId = window.clientVars?.padId;
            const xsrf = getXSRF();
            const res = await axios.post(url, { fileId: padId, isCancel }, { params: { xsrf }, headers: { 'X-XSRF-TOKEN': xsrf } });
            const { data } = res;

            if (data.retcode !== 0) {
                return Infinity;
            }
            return data.retcode;
        } catch (e) {
            return Infinity;
        }
    }

    /**
     * 显示认证标签的提示
     */
    protected getOpenTips(flag: boolean): string {
        if (flag) {
            return i18n.t('已为当前文档展示官方认证信息');
        }
        return i18n.t('展示官方认证信息失败');
    }

    /**
     * 关闭认证标签的提示
     */
    protected getCloseTips(flag: boolean): string {
        if (flag) {
            return i18n.t('已关闭当前文档的官方认证信息');
        }
        return i18n.t('关闭官方认证信息失败');
    }
}
